import api from "js/api.js";

api.defaults.headers.common["X-CSRF-TOKEN"] = document.getElementsByName("X-CSRF-TOKEN")[0].getAttribute("content");
api.defaults.headers.common["x-auth-token"] = localStorage.getItem("token_" + window.bo_site);
api.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("token_" + window.bo_site);

export default {
    methods: {
        async get(url, payload) {
            return await api.get(url, payload);
        },

        async post(url, payload) {
            return await api.post(url, payload);
        },

        async processData(method, url, payload, success = null, failure = null) {
            let data = null;
            try {
                let response = await method(url, payload);
                data = response.data;
                if (success) success(response);
            } catch (error) {
                if (failure) failure(error);
            }

            return data;
        },

        async getColumnPreferenceData(url, success, failure) {
            return await this.processData(this.get, url, null, success, failure);
        },

        async saveColumnPreferenceData(url, payload, success, failure) {
            return await this.processData(this.post, url, payload, success, failure);
        },
    },
};
